import Cookies from "js-cookie"; 

const ACCESS_TOKEN_KEY = 'accessToken';

export const isSabAuthenticated = () => {
  const sabAuthenticated = document.cookie.includes(ACCESS_TOKEN_KEY);
  return sabAuthenticated;
}

export const saveAccessToken = (token) => {
  Cookies.set(ACCESS_TOKEN_KEY, token)
}

export const getAccessToken = () => {
  return Cookies.get(ACCESS_TOKEN_KEY)
}

export const clearAccessToken = () => {
  Cookies.remove(ACCESS_TOKEN_KEY)
  localStorage.clear()
}

